import lodash from "lodash";
import { repopulate, setEmailErrMsg } from "./EmailGenerationUtils";

// TYPES

export const AI_DESC_EG_UPDATE_PURPOSE = "AI_DESC_EG_UPDATE_PURPOSE";
export const AI_DESC_EG_HANDLE_PURPOSE_DROPDOWN_OPEN =
    "AI_DESC_EG_HANDLE_PURPOSE_DROPDOWN_OPEN";
export const AI_DESC_EG_UPDATE_TONE = "AI_DESC_EG_UPDATE_TONE";
export const AI_DESC_EG_HANDLE_TONE_DROPDOWN_OPEN =
    "AI_DESC_EG_HANDLE_TONE_DROPDOWN_OPEN";
export const AI_DESC_EG_UPDATE_OTHER_PURPOSE =
    "AI_DESC_EG_UPDATE_OTHER_PURPOSE";
export const AI_DESC_EG_UPDATE_SUBJECT = "AI_DESC_EG_UPDATE_SUBJECT";
export const AI_DESC_EG_UPDATE_DETAILS = "AI_DESC_EG_UPDATE_DETAILS";
export const AI_DESC_EG_UPDATE_EMAIL = "AI_DESC_EG_UPDATE_EMAIL";
export const AI_DESC_EG_UPDATE_EMAIL_ISEDITING =
    "AI_DESC_EG_UPDATE_EMAIL_ISEDITING";
export const AI_DESC_EG_GENERATE_EMAIL = "AI_DESC_EG_GENERATE_EMAIL";
export const AI_DESC_EG_REGENERATE_EMAIL = "AI_DESC_EG_REGENERATE_EMAIL";
export const AI_DESC_EG_HANDLE_ACTION_EMAIL = "AI_DESC_EG_HANDLE_ACTION_EMAIL";
export const AI_DESC_EG_FETCH_EMAIL = "AI_DESC_EG_FETCH_EMAIL";
export const AI_DESC_EG_UNDO_EMAIL = "AI_DESC_EG_UNDO_EMAIL";
export const AI_DESC_EG_UPDATE_PAGE_TYPE = "AI_DESC_EG_UPDATE_PAGE_TYPE";
export const AI_DESC_EG_UPDATE_ACTION_EMAIL = "AI_DESC_EG_UPDATE_ACTION_EMAIL";
export const AI_DESC_EG_HANDLE_SEVER_BUSY_POPUP =
    "AI_DESC_EG_HANDLE_SEVER_BUSY_POPUP";
export const AI_DESC_EG_HANDLE_REPOPULATE_EMAIL =
    "AI_DESC_EG_HANDLE_REPOPULATE_EMAIL";
export const AI_DESC_EG_CLEAR = "AI_DESC_EG_CLEAR";

// ACTIONS

export const handleEgPurposeDdOpen = (payload) => ({
    type: AI_DESC_EG_HANDLE_PURPOSE_DROPDOWN_OPEN,
    payload,
});

export const updateEgPurpose = (payload) => ({
    type: AI_DESC_EG_UPDATE_PURPOSE,
    payload,
});

export const handleEgToneDdOpen = (payload) => ({
    type: AI_DESC_EG_HANDLE_TONE_DROPDOWN_OPEN,
    payload,
});

export const updateEgTone = (payload) => ({
    type: AI_DESC_EG_UPDATE_TONE,
    payload,
});

export const updateEgOtherPurpose = (payload) => ({
    type: AI_DESC_EG_UPDATE_OTHER_PURPOSE,
    payload,
});

export const updateEgSubject = (payload) => ({
    type: AI_DESC_EG_UPDATE_SUBJECT,
    payload,
});

export const updateEgDetails = (payload) => ({
    type: AI_DESC_EG_UPDATE_DETAILS,
    payload,
});

export const updateEgDesc = (payload) => ({
    type: AI_DESC_EG_UPDATE_EMAIL,
    payload,
});

export const updateEgDescIsEditing = (payload) => ({
    type: AI_DESC_EG_UPDATE_EMAIL_ISEDITING,
    payload,
});

export const fetchEmailDesc = (payload) => ({
    type: AI_DESC_EG_FETCH_EMAIL,
    payload,
});

export const handleEmailDescUndo = (payload) => ({
    type: AI_DESC_EG_UNDO_EMAIL,
    payload,
});

export const updateActionEmailDesc = (payload) => ({
    type: AI_DESC_EG_UPDATE_ACTION_EMAIL,
    payload,
});

export const updateEgPageType = (payload) => ({
    type: AI_DESC_EG_UPDATE_PAGE_TYPE,
    payload,
});

export const handleRepopulateEg = (payload) => ({
    type: AI_DESC_EG_HANDLE_REPOPULATE_EMAIL,
    payload,
});

export const clearEmailDetails = (payload) => ({
    type: AI_DESC_EG_CLEAR,
    payload,
});

export const handleEgSeverBusyPopup = (payload) => ({
    type: AI_DESC_EG_HANDLE_SEVER_BUSY_POPUP,
    payload,
});

// Actions to trigger saga generators

export const generateEmailDesc = (payload) => ({
    type: AI_DESC_EG_GENERATE_EMAIL,
    payload,
});

export const regenerateEmailDesc = (payload) => ({
    type: AI_DESC_EG_REGENERATE_EMAIL,
    payload,
});

export const handleActionEmailDesc = (payload) => ({
    type: AI_DESC_EG_HANDLE_ACTION_EMAIL,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    order_id: `${Date.now() + Math.floor(Math.random() * 100)}`,
    purpose: {
        title: "Select purpose",
        defaultTitle: "Select purpose",
        dropDownList: [
            "Newsletter",
            "Cold introduction",
            "Request a review",
            "Request a referral",
            "Open house alert",
            "Open house follow up",
            "Home value campaign",
            "Reaching FSBO Leads",
            "Share a market update",
            "Low-interest rate email",
            "Holiday/festival greeting",
            "One-year follow-up email",
            "Neighborhood expertise email",
            "Follow-up email to clarify buyer’s needs",
            "Contacting owners in a specific neighborhood",
            "Thank you email to a client who just sold the house",
            "Thank you email to a client who just bought a new house",
            "Expired listing outreach (when you are the listing agent)",
            "Expired listing outreach (when you are not the listing agent)",
            "Under contract follow-up email (to a home owner/seller)",
            "Under contract follow-up email (to a buyer interested in a property already under contract)",
            "Any other purpose",
        ],
        isSelectedOthers: false,
        selectedItem: "",
        otherPurpose: "",
        isOpen: false,
    },
    tone: {
        title: "Select tone",
        defaultTitle: "Select tone",
        dropDownList: [
            "Select tone",
            "Professional",
            "Friendly",
            "Respectful",
            "Formal",
            "Informal",
            "Funny",
        ],
        selectedItem: "",
        isOpen: false,
    },
    subject: "",
    mainPoints: "",
    emailGenerated: [
        // {
        //     status: "Just now",
        //     generatedDesc:
        //         "application\n\n\n\nHello, \n\nI am writing to inform you that I am going to be taking a leave of absence from work. I will be gone for two weeks starting on Monday. Thank you for understanding and I hope everything goes well while I'm away. \n\nSincerely, \n[Your Name]",
        //         editedDesc: "",
        //     isEditing: false,
        //     isEdited: false,
        //     liked: null,
        //     generated_at: Date.now(),
        // },
    ],
    isGenEmailBtnHidden: false,
    isGenEmailBtnDisabled: true,
    isEmailGenerating: false,
    errMsg: "Please fill the required fields.",
    repopulate: false,
    pageType: "Marketing Emails",
    popups: {
        busyServer: {
            show: false,
        },
    },
};

const EmailGenerationReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case AI_DESC_EG_CLEAR: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${
                Date.now() + Math.floor(Math.random() * 100)
            }`;
            return { ...temp_state };
        }
        case AI_DESC_EG_HANDLE_PURPOSE_DROPDOWN_OPEN: {
            const { isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state.purpose.isOpen = isOpen;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_PURPOSE: {
            const { purp } = action.payload;
            let temp_state = { ...state };
            let purposeObj = temp_state["purpose"];
            if (
                purp === "Holiday/festival greeting" ||
                purp === "Any other purpose"
            ) {
                purposeObj["isSelectedOthers"] = true;
            } else {
                purposeObj["isSelectedOthers"] = false;
            }
            purposeObj["selectedItem"] = purp;
            purposeObj["title"] = purp;
            // }
            temp_state.isGenEmailBtnHidden = false;
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_HANDLE_TONE_DROPDOWN_OPEN: {
            const { isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state.tone.isOpen = isOpen;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_TONE: {
            const { tone } = action.payload;
            let temp_state = { ...state };
            let toneObj = temp_state["tone"];
            if (toneObj["defaultTitle"] == tone) {
                toneObj["selectedItem"] = "";
                toneObj["title"] = toneObj["defaultTitle"];
            } else {
                toneObj["selectedItem"] = tone;
                toneObj["title"] = tone;
            }
            temp_state.isGenEmailBtnHidden = false;
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_OTHER_PURPOSE: {
            const { otherPurp } = action.payload;
            let temp_state = { ...state };
            temp_state["purpose"]["otherPurpose"] = otherPurp;
            temp_state.isGenEmailBtnHidden = false;
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_SUBJECT: {
            const { subject } = action.payload;
            let temp_state = { ...state };
            temp_state["subject"] = subject;
            temp_state.isGenEmailBtnHidden = false;
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_DETAILS: {
            const { details } = action.payload;
            let temp_state = { ...state };
            temp_state["mainPoints"] = details;
            temp_state.isGenEmailBtnHidden = false;
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_EMAIL: {
            const { descInd, desc } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.emailGenerated;
            emailGen[descInd]["editedDesc"] = desc;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_EMAIL_ISEDITING: {
            const { isEditing, descInd } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.emailGenerated;
            emailGen[descInd]["isEditing"] = isEditing;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_FETCH_EMAIL: {
            let temp_state = { ...state };
            const { emails } = action.payload;
            temp_state.isGenEmailBtnHidden = true;
            temp_state.emailGenerated = emails;
            temp_state["isEmailGenerating"] = false;
            temp_state["pageType"] = "Generated Section";
            temp_state.repopulate = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_ACTION_EMAIL: {
            const { descInd, actionInfo, isEdited } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.emailGenerated;
            Object.keys(actionInfo).forEach((actKey) => {
                emailDesc[descInd][actKey] = actionInfo[actKey];
            });
            emailDesc[descInd]["isEdited"] = isEdited;
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UNDO_EMAIL: {
            const { descInd } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.emailGenerated;
            emailDesc[descInd]["editedDesc"] =
                emailDesc[descInd]["description_generated"];
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_GENERATE_EMAIL: {
            let temp_state = { ...state };
            temp_state["isEmailGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_REGENERATE_EMAIL: {
            let temp_state = { ...state };
            temp_state["isEmailGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_UPDATE_PAGE_TYPE: {
            const { pageType } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType = pageType;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_HANDLE_REPOPULATE_EMAIL: {
            const { data } = action.payload;
            let temp_state = { ...state };
            repopulate(temp_state, data);
            setEmailErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_EG_HANDLE_SEVER_BUSY_POPUP: {
            let temp_state = { ...state };
            const { isShow } = action.payload;
            temp_state.popups.busyServer.show = isShow;
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default EmailGenerationReducer;
